import SupportConversationPage from "../../common/SupportChat/SupportConversationPage";
import Seo from "../../Seo";
import L from "../../../constants/baysportLabels";

export default function OwnerSupport() {
  return (
    <>
      <Seo noindex title={`Поддержка — ${L.productName}`} />
      <SupportConversationPage
        mode="owner"
        shell="owner"
        title="Поддержка Бай.Спорт"
        subtitle="Команда платформы"
        backTo="/account/clubs"
        fullscreen
      />
    </>
  );
}
